module.exports = __webpack_public_path__ + "static/media/descifraLogo.76fc36b9.svg";